var _path, _rect, _rect2, _path2, _circle, _circle2, _rect3, _path3, _circle3, _circle4, _circle5, _circle6, _path4, _rect4, _path5, _path6, _rect5, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMosque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 80 Q100 20 140 80",
    fill: "#ffd700",
    opacity: 0.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 78,
    width: 84,
    height: 42,
    rx: 2,
    fill: "#ffd700",
    opacity: 0.85
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 50,
    width: 14,
    height: 70,
    rx: 2,
    fill: "#ffd700",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52 Q37 30 44 52",
    fill: "#ffd700",
    opacity: 0.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36,
    r: 5,
    fill: "#ffd700",
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 35,
    r: 4,
    fill: "#2c5530"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 50,
    width: 14,
    height: 70,
    rx: 2,
    fill: "#ffd700",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 52 Q163 30 170 52",
    fill: "#ffd700",
    opacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 36,
    r: 5,
    fill: "#ffd700",
    opacity: 0.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 35,
    r: 4,
    fill: "#2c5530"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 30,
    r: 7,
    fill: "#ffd700"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 28,
    r: 5.5,
    fill: "#2c5530"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 120 Q100 95 112 120",
    fill: "#2c5530",
    opacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 118,
    width: 24,
    height: 2,
    fill: "#2c5530",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70 90 Q77 82 84 90",
    fill: "#2c5530",
    opacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116 90 Q123 82 130 90",
    fill: "#2c5530",
    opacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 118,
    width: 160,
    height: 6,
    rx: 2,
    fill: "#ffd700",
    opacity: 0.7
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 1.5,
    fill: "#ffd700",
    opacity: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 15,
    r: 1.5,
    fill: "#ffd700",
    opacity: 0.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 45,
    r: 1,
    fill: "#ffd700",
    opacity: 0.4
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 40,
    r: 1,
    fill: "#ffd700",
    opacity: 0.4
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 10,
    r: 1,
    fill: "#ffd700",
    opacity: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 8,
    r: 1,
    fill: "#ffd700",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosque);
export default __webpack_public_path__ + "static/media/mosque.8e8734609f3729d86493e1b15778915f.svg";
export { ForwardRef as ReactComponent };